import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Logo } from '@shared/ui';

interface PasswordResetLayoutProps {
  topRight?: ReactNode;
  stepIndicator: ReactNode;
  children: ReactNode;
  promo: ReactNode;
}

export function PasswordResetLayout({ topRight, stepIndicator, children, promo }: PasswordResetLayoutProps) {
  const { t } = useTranslation();
  return (
    <div className="grid h-dvh w-full grid-cols-1 overflow-hidden bg-base nav:grid-cols-2">
      <div className="flex h-dvh flex-col overflow-y-auto px-5 py-8 sm:px-8 nav:h-screen nav:px-12 nav:py-10">
        <div className="mb-8 flex flex-wrap items-center justify-between gap-4">
          {stepIndicator}
          {topRight}
        </div>
        <Logo />
        <div className="flex flex-1 flex-col justify-center py-10">{children}</div>
        <div className="text-[12px] font-medium uppercase tracking-[0.14em] text-muted-2">{t('auth.versionSecure')}</div>
      </div>
      <div className="hidden nav:flex">{promo}</div>
    </div>
  );
}
